<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">{{ routeName }}</a>
      <button
        class="navbar-toggler navbar-burger"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>

      <div class="collapse navbar-collapse">
        <logout-button />
        <button class="btn btn-outline-info" @click="toggleRightSidebar">
          <span v-if="showRightSidebar">Hide Tasks</span>
          <span v-else>Check Tasks</span>

          <span
            v-if="showTasksHaveUpdates"
            class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"
          ></span>
        </button>
      </div>
    </div>
  </nav>
</template>
<script>
import LogoutButton from "../../components/Buttons/LogoutButton.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    LogoutButton
  },
  data() {
    return {
      activeNotifications: false
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleRightSidebar() {
      this.$store.commit("dashboard/toggleRightSidebar");
      this.$store.commit("task/setTasksHaveUpdates", false);
    }
  },
  computed: {
    ...mapGetters("dashboard", ["showRightSidebar"]),
    ...mapGetters("task", ["showTasksHaveUpdates"]),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  }
};
</script>
